import React, { useState } from "react";
import { useTokenStore } from "../../store/TokenStore";
import { ApiRequest } from "../../api/Api";
import { Button } from "../Button/Button";

export const LoginForm = () => {
	const [login, setLogin] = useState<string>("");
	const [password, setPassword] = useState<string>("");
	const [token, setToken] = useState<string>("");
	const TokenUpdate = useTokenStore((state) => state.TokenUpdate);

	const submitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		const response = await ApiRequest("/auth/login", {
			login,
			password,
			token,
		});

		if (response?.status === "success") {
			TokenUpdate(response.data);
		}
	};

	return (
		<form method="post" onSubmit={(e) => submitHandler(e)}>
			<input
				type="text"
				placeholder="Login"
				onChange={(e) => setLogin(e.target.value)}
				value={login}
			/>
			<input
				type="password"
				placeholder="Password"
				onChange={(e) => setPassword(e.target.value)}
				value={password}
			/>
			<input
				type="text"
				placeholder="Token"
				onChange={(e) => setToken(e.target.value)}
				value={token}
			/>
			<Button type="submit">Войти</Button>
		</form>
	);
};
